import { DEFAULT_API_CONFIG } from './apiConfig';

const { url, getHeaders } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/RecommendationTypes`;

export const createRecommendationType = async recommendationType => {
  const url = `${baseRoute}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(recommendationType),
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const updateRecommendationType = async recommendationType => {
  const url = `${baseRoute}/${recommendationType.recommendationTypeId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(recommendationType),
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getRecommendationTypeById = async recommendationTypeId => {
  const url = `${baseRoute}/${recommendationTypeId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getRecommendationTypes = async () => {
  const url = `${baseRoute}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const removeRecommendationTypeById = async recommendationTypeId => {
  const url = `${baseRoute}/${recommendationTypeId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'DELETE',
    headers,
    // body: JSON.stringify(recommendationType),
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};
